module.exports = __webpack_public_path__ + "img/zhxy_image_0.7ebaa641.png";